// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"815a361e","667":"6b166861","977":"2d74447c"}[chunkId] + ".chunk.js";
};